import React, { Component, useState, useEffect } from 'react'
import HighlightTable from '../component/HighlightTable'
import HighlightsFh from './highlightsFh'

export default function Highlights() {
    const [activetab, setActivetab] = useState(0)
    const [data, setData] = useState([
        {
            "label": "manage Highlights",
            "Content": "",
        },
        {
            "label": "featured highlights",
            "Content": "",
        },
    ])
    const TabClick = (index) => {
        setActivetab(index)
    }
    return (
        <React.Fragment>
            <div className="right_side_wrapper artistView_wrapper">
                <div className="relative">
                    <ul className="fpg_admin_tab disp_flex small_list_tab">
                        {
                            data && data.map((list, index) => {
                                return (
                                    <li className={activetab === index ? 'active' : ''} onClick={() => TabClick(index)} key={index}>
                                        <p className="uppercase text_center">
                                            <div>
                                                {list.label}
                                            </div>
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    
                    <span className="pointer" style={{position:"absolute",right:"20px",top:"20px"}}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM11 16H9V14H11V16ZM11.976 11.115C11.78 11.273 11.591 11.424 11.441 11.574C11.033 11.981 11.001 12.351 11 12.367V12.5H9V12.333C9 12.215 9.029 11.156 10.026 10.159C10.221 9.964 10.463 9.766 10.717 9.56C11.451 8.965 11.933 8.531 11.933 7.933C11.9214 7.42782 11.7125 6.94725 11.3511 6.59412C10.9896 6.24099 10.5043 6.04334 9.99901 6.04347C9.4937 6.0436 9.0085 6.2415 8.64725 6.59482C8.28599 6.94814 8.07736 7.42881 8.066 7.934H6.066C6.066 5.765 7.831 4 10 4C12.169 4 13.934 5.765 13.934 7.934C13.934 9.531 12.755 10.484 11.976 11.115Z" fill="white"/>
                        </svg>
                    </span>
                    
                </div>
                {
                    activetab === 0 ?
                        <>
                            <div className="table_wrap highlight_tbl">
                                <HighlightTable />
                            </div>

                            {/* <div className="text_center field_row w_100 buttons_outer">
                                <button className="uppercase">CANCEL</button>
                                <button className="uppercase active">SAVE</button>
                            </div> */}
                        </>
                        : ''
                }
                {
                    activetab === 1 ?
                        <>
                            <HighlightsFh />
                        </>
                        :
                        ''
                }
            </div>
        </React.Fragment>
    )
}
